module.exports = __webpack_public_path__ + "img/DS-M-13.890070d7.svg";